export type PaymentLocation = 1 | 2 | 3;
export const PaymentLocation = {
    Origen: 1 as PaymentLocation,
    Destino: 2 as PaymentLocation,
    Cuenta: 3 as PaymentLocation
};
